const ShieldCheckIcon = () => (
  <svg
    aria-hidden="true"
    fill="none"
    height="24"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const CouponVerificationCard = () => (
  <div className="rounded-4 border-2 border-success-200 bg-neutral-high-100 p-4 dark:bg-neutral-low-500">
    <div className="mb-2 flex items-center gap-2">
      <span className="shrink-0 text-success-300">
        <ShieldCheckIcon />
      </span>
      <span className="text-lg font-bold text-neutral-low-400 dark:text-neutral-high-200">
        Como verificamos nossos cupons
      </span>
    </div>
    <div className="flex flex-col gap-3">
      <p className="font-normal text-base text-neutral-low-300 dark:text-neutral-high-300">
        Os cupons do Promobit vêm de parcerias comerciais com redes de afiliados
        e contribuições da comunidade. Prezamos pela qualidade dos mesmos,
        buscando sempre trazer as melhores condições das ofertas em cada loja.
        Em ambos os casos, cupons que deixam de funcionar são movidos para a
        seção de expirados.
      </p>
      <p className="font-normal text-base text-neutral-low-300 dark:text-neutral-high-300">
        Monitoramos a validade e o tempo de vida de cada cupom. Indicadores
        visuais ajudam você a identificar os cupons com maior chance de
        funcionar. Isso é uma das formas de priorizar a transparência e a
        experiência da página, trazendo as informações necessárias para os
        usuários.
      </p>
    </div>
  </div>
);

export default CouponVerificationCard;
